import { render, staticRenderFns } from "./MyPageChangePassword.vue?vue&type=template&id=6af44fd0&scoped=true&"
import script from "./MyPageChangePassword.vue?vue&type=script&lang=js&"
export * from "./MyPageChangePassword.vue?vue&type=script&lang=js&"
import style0 from "./MyPageChangePassword.vue?vue&type=style&index=0&id=6af44fd0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6af44fd0",
  null
  
)

export default component.exports